import Vue from 'vue'
import Progress from './Progress'
import Buttons from './Buttons'

Vue.component('wizard-progress', Progress)
Vue.component('wizard-buttons', Buttons)
